import { Component, Inject, OnInit, Optional } from "@angular/core";
import { FormControl } from "@angular/forms";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { IDropdownSettings } from "ng-multiselect-dropdown";
import { ToastrService } from "ngx-toastr";
import { EmployeeService } from "../employee-profile/employee-profile.service";

@Component({
  selector: "edit-employee",
  templateUrl: "./edit-employee.component.html",
  styleUrls: ["./edit-employee.component.css"],
})
export class EditEmployeeComponent implements OnInit {
  isSme: boolean;
  isRole: boolean;
  isAdmin: boolean;
  isSameEmp: boolean;
  isAdminSelected: boolean;
  constructor(
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    @Optional() public dialogRef: MatDialogRef<EditEmployeeComponent>,
    private employeeService: EmployeeService,
    private toastr: ToastrService
  ) {}
  dropdownSettings: IDropdownSettings = {};
  allSkills = [];
  SMETechlist = [];
  selectedSkills = this.data.skill ? this.data.skill : [];
  selectedSME = this.data.sme ? this.data.sme : [];
  ngOnInit() {
    var role = localStorage.getItem("role");
    this.isAdmin = role == "Admin" ? true : false;
    var empId = localStorage.getItem("Id");
    this.isSameEmp = this.data.employeeId + "" == empId ? true : false;
    this.isSme = this.data.sme.length ? true : false;

    this.dropdownSettings = {
      singleSelection: false,
      idField: "skill",
      textField: "skill",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 3,
      allowSearchFilter: true,
    };
    //todo: has to come from API
    this.allSkills = [
      "Management",
      "Tech Manager",
      "SNA",
      "Java",
      ".Net",
      "BI",
      "Quality Assurance",
      "BA",
      "Mobile",
      "Sales",
      "Admin",
      "HR",
      "PHP",
      "Devops",
      "Python",
      "Finance and Accounts",
      "UI/UX",
      "Ruby",
      "RPA",
      "L&D",
      "Data-Science",
      "Marketing",
      "Blockchain",
      "PMO",
      "TA",
      "React Native",
      "Salesforce",
      "Trainer",
    ];
    this.SMETechlist = [
      "Microsoft .NET",
      "Microsoft SQL Serevr",
      "Hyper-V",
      "Power BI",
      "JAVA",
      "JMeter",
      "SpringBoot",
      "Hybernate",
      "Python",
      "Python for Computer Vision",
      "Angular",
      "React JS",
      "Vue JS",
      "AWS",
      "Azure",
      "GCP",
      "Cyber Security",
      "Pen Testing",
      "Fortinet",
      "CISCO",
      "CCNA",
      "CISSP",
    ];
  }
  confirm() {
    this.employeeService
      .updateEmployee({
        SME: this.data.sme,
        skill: this.data.skill,
        EmployeeId: this.data.employeeId,
      })
      .subscribe((res) => {
        this.dialogRef.close(true);
      });
    if (this.isAdmin) {
      this.employeeService
        .updateRole(this.data.employeeId, this.isAdminSelected)
        .subscribe(
          (res) => {
            this.toastr.success("Successfully Updated");
          },
          (error) => {
          }
        );
    }
  }

  cancel() {
    this.data.sme = this.selectedSME;
    this.data.skill = this.selectedSkills;
    this.dialogRef.close(true);
  }
}
